
import React from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { UseFormRegister } from 'react-hook-form';
import { ExamResult } from '@/utils/exam/types';

interface ExamAdditionalFieldsProps {
  register: UseFormRegister<Partial<ExamResult>>;
}

const ExamAdditionalFields: React.FC<ExamAdditionalFieldsProps> = ({ register }) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="remarks" className="text-base">Remarks (Optional)</Label>
      <Textarea
        id="remarks"
        {...register('remarks')}
        placeholder="Add any additional notes or remarks about the exam..."
        className="min-h-[100px]"
      />
    </div>
  );
};

export default ExamAdditionalFields;
